import { TOGGLE_GAQ_ANALYTICS_BU_FILTER } from "../../../../../actions";

export const toggleGAQAnalyticsBUFilter = (payload) => ({
  type: TOGGLE_GAQ_ANALYTICS_BU_FILTER,
  payload,
});
